module.exports = __webpack_public_path__ + "static/media/enköpingvapen.c7c9bd32.png";